import { render, staticRenderFns } from "./gameList.vue?vue&type=template&id=fcaf359a&scoped=true&"
import script from "./gameList.vue?vue&type=script&lang=js&"
export * from "./gameList.vue?vue&type=script&lang=js&"
import style0 from "./gameList.vue?vue&type=style&index=0&id=fcaf359a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaf359a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcaf359a')) {
      api.createRecord('fcaf359a', component.options)
    } else {
      api.reload('fcaf359a', component.options)
    }
    module.hot.accept("./gameList.vue?vue&type=template&id=fcaf359a&scoped=true&", function () {
      api.rerender('fcaf359a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/gameList.vue"
export default component.exports